// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__kaiJj","title":"Info_title__o87nO","selects":"Info_selects__-mntI","requiredAsterisk":"Info_requiredAsterisk__3FD0M"};